const reasons = [
  'сотрудник не понимает, зачем нужны изменения;',
  'не видит личной выгоды от нового порядка;',
  'боится потерять статус или влияние;',
  'не уверен, что справится с новым процессом;',
  'уже привык работать по старой системе;',
  'не доверяет руководству;',
  'не понимает, что конкретно изменится в его работе;',
  'ранее сталкивался с неудачными изменениями;',
  'опасается роста нагрузки;',
  'не получил необходимых навыков;',
  'считает новое решение неэффективным.',
];

export default function WhyResistance() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Почему изменения вызывают сопротивление
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Сопротивление не всегда означает саботаж или плохое отношение к компании. Причины могут быть разными:
        </p>

        <div className="grid sm:grid-cols-2 gap-3 max-w-4xl mx-auto mb-12">
          {reasons.map((r, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-white rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-question-mark text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{r}</span>
            </div>
          ))}
        </div>

        <div className="bg-gray-900 rounded-2xl p-6 md:p-10 text-center">
          <p className="text-base md:text-xl text-white leading-relaxed font-semibold">
            Сопротивление необходимо не только преодолевать — его нужно понимать и правильно с ним работать.
          </p>
        </div>
      </div>
    </section>
  );
}